import { render, staticRenderFns } from "./Tvl.vue?vue&type=template&id=5770509d&"
import script from "./Tvl.vue?vue&type=script&lang=js&"
export * from "./Tvl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports